export default __webpack_public_path__ + "static/layer-813f4536686a421250e647908d2056ba.svg";